import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Logging service for consistent error/warning/info logging across the application.
 * - Development: All log levels (log, warn, error) are printed to console
 * - Production: Only errors are printed to console; consider integrating with Application Insights
 */
@Injectable({ providedIn: 'root' })
export class LoggerService {
  /**
   * Log informational messages (development only)
   */
  log(message: string, ...data: unknown[]): void {
    if (!environment.production) {
      console.log(`[TCO-CET] ${message}`, ...data);
    }
  }

  /**
   * Log warnings (development only)
   */
  warn(message: string, ...data: unknown[]): void {
    if (!environment.production) {
      console.warn(`[TCO-CET] ${message}`, ...data);
    }
  }

  /**
   * Log errors (always logged)
   * In production, consider sending to Application Insights or similar service
   */
  error(message: string, error?: unknown): void {
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.error(`[TCO-CET] ERROR: ${message}`, errorMessage);

    // TODO: Integrate with Application Insights
    // if (environment.production) {
    //   this.appInsights.trackException({ exception: error });
    // }
  }

  /**
   * Log debug messages (development only, verbose)
   */
  debug(message: string, ...data: unknown[]): void {
    if (!environment.production) {
      console.debug(`[TCO-CET] DEBUG: ${message}`, ...data);
    }
  }
}
